<div class="mat-dialog-device device-modal rounded-1">
  <div class="header rounded-1">
    <strong>{{ (data.device ? 'BUTTONS.MODIFY_DEVICE' : 'BUTTONS.NEW_DEVICE') | translate}}</strong>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()"></button>
  </div>

  <div class="new-device-content">
    <form [formGroup]="deviceForm">
      <div class="d-flex justify-content-between align-items-start">
        <div class="mb-3 me-3" style="flex: 1;">
          <label class="form-label" for="serialNumber">{{ 'DEVICE.SERIAL_NUMBER' | translate }}<span
              class="text-danger">*</span></label>
          <input class="form-control" id="serialNumber" type="text" formControlName="serialNumber"
            placeholder="Device serial number" required />
          <div class="error-container">
            <div *ngIf="deviceForm.get('serialNumber')?.invalid && deviceForm.get('serialNumber')?.touched"
              class="text-danger small-error">
              {{ 'ERRORS.SERIAL_NUMBER_REQUIRED' | translate }}
            </div>
          </div>
        </div>

        <div class="mb-3" style="flex: 1;">
          <label class="form-label" for="companyName">{{ 'DEVICE.COMPANY' | translate }} <span
              class="text-danger">*</span></label>
          <ng-select
            class="company-select"
            [items]="companiesList"
            bindLabel="name"
            bindValue="id"
            [placeholder]="'PLACEHOLDERS.SELECT_COMPANY' | translate"
            formControlName="selectedCompanyId"
            appendTo="body"
            dropdownPosition="top"
            [searchable]="true"
            [clearable]="false"
            (change)="onDropdownSelected()">
          </ng-select>
          <div class="error-container">
            <div *ngIf="deviceForm.get('selectedCompanyId')?.invalid && deviceForm.get('selectedCompanyId')?.touched"
              class="text-danger small-error">
              {{ 'ERRORS.COMPANY_REQUIRED' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center mb-3">
        <span class="star-icon me-2" [ngClass]="deviceForm.get('favorite')?.value ? 'fas fa-star' : 'far fa-star'"
          (click)="deviceForm.get('favorite')?.setValue(!deviceForm.get('favorite')?.value)" role="button"
          tabindex="0"></span>
        <label class="form-check-label mb-0">
          {{ 'DEVICE.FAVORITE' | translate }}
        </label>
      </div>

      <div class="mb-3">
        <label class="form-label" for="siteId">Site</label>
        <ng-select
          class="site-select"
          [items]="sitesList"
          bindLabel="nom"
          bindValue="siteId"
          placeholder="Select site"
          formControlName="siteId"
          appendTo="body"
          dropdownPosition="top"
          [searchable]="true"
          [clearable]="true"
          (change)="onDropdownSelected()">
        </ng-select>
      </div>

      <div class="mb-3">
        <label class="form-label">Timezone</label>

        <ng-select
          class="timezone-select"
          [items]="timeZones"
          bindLabel="displayName"
          bindValue="id"
          placeholder="Select timezone"
          formControlName="timeZoneId"
          (change)="onDropdownSelected()"
          appendTo="body"
          dropdownPosition="top"
          [searchable]="true"
          [clearable]="true">

          <ng-template ng-label-tmp let-item="item">
            {{ item.displayName || item.name }}
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            {{ item.displayName || item.name }}
          </ng-template>

        </ng-select>
      </div>
    </form>
  </div>

  <div class="button-group">
    <button class="secondary-button popup-secondary-button me-2" (click)="closeDialog()">{{ 'BUTTONS.CANCEL' | translate }}</button>
    <button class="primary-button popup-primary-button" (click)="confirm()"
      [disabled]="!deviceForm.get('serialNumber')?.value || !deviceForm.get('selectedCompanyId')?.value">
      {{'BUTTONS.CONFIRM' | translate }}</button>
  </div>
</div>